import { ChainId } from '@src/configs/chainInfo'
import { GasFeeSimulationResults } from '@src/types/gasFees'
import { PrecomputeGasResults } from '@src/types/gasPrices'
import { gasFeeslogger } from '@src/utils/logger'

export const approximateGasFeesSolana = (
    precomputedGasPrices: PrecomputeGasResults,
    precomputed_results: GasFeeSimulationResults[]
): GasFeeSimulationResults => {
    try {
        if (!precomputedGasPrices[ChainId.Solana]) {
            throw new Error(`[approximateGasFees] precomputedGasPrices does not contain data for Solana`)
        }

        return {
            totalGasUnits: BigInt(0),
            indivdualGasUnits: [BigInt(0)],
            totalFeePerGasUnit: BigInt(0),
            feeMetrics: precomputed_results[0].feeMetrics,
            solanaResults: {
                feeInLamports: precomputed_results[0].solanaResults?.feeInLamports,
            },
        } as GasFeeSimulationResults
    } catch (err) {
        gasFeeslogger.error('Cannot approximate Solana gas fees', { error: err })
        return {
            totalGasUnits: BigInt(0),
            indivdualGasUnits: [BigInt(0)],
            totalFeePerGasUnit: BigInt(0),
            feeMetrics: {},
        } as GasFeeSimulationResults
    }
}
